@if (this.isReady) {
  <div class="control-container">
    @if (this.show().search) {
      <div class="control-search">
        <cam-search-displayer
          [placeholder]="this.show().searchPlaceholder ?? ''"
          [searchHistory]="{
            type: this.gridId(),
          }"
          (valueCompleted)="this.searchSelected($event)"
          container="link"
        ></cam-search-displayer>
      </div>
    }

    @if (this.show().views) {
      <cam-views-selection-displayer
        [gridId]="this.gridId()"
        [label]="'grid.control.views' | translate"
        [size]="this.size()"
      ></cam-views-selection-displayer>
    }

    @if (this.show().fields) {
      <cam-fields-selection-displayer
        [gridId]="this.gridId()"
        [label]="'grid.control.fields' | translate"
        [size]="this.size()"
      ></cam-fields-selection-displayer>
    }

    @if (this.show().filters) {
      <cam-filter-displayer
        container="link"
        [count]="this.filterCount"
        [form]="this.filtersForm()"
        [label]="'grid.control.filters' | translate"
        [size]="this.size()"
        (filtersSelected)="this.filtersSelected($event)"
      ></cam-filter-displayer>
    }

    @if (this.isTreeData && this.displayType() === 'grid') {
      @if (!this.isOneExpand) {
        <cam-button type="secondary" [size]="this.size()" icon="expand" (action)="this.expandAll()">
          {{ 'grid.control.expand' | translate }}
        </cam-button>
      } @else {
        <cam-button type="secondary" [size]="this.size()" icon="collapse" (action)="this.collapseAll()">
          {{ 'grid.control.collapse' | translate }}
        </cam-button>
      }
    }

    @if (this.show().treeMode) {
      <cam-button
        [size]="this.size()"
        icon="sort-list"
        [type]="this.treeMode ? 'primary' : 'secondary'"
        (action)="this.toggleTreeMode()"
      ></cam-button>
    }

    @if (this.show().flatView) {
      <cam-button
        [size]="this.size()"
        icon="listing"
        [type]="!this.treeMode ? 'primary' : 'secondary'"
        (action)="this.toggleFlatView()"
      ></cam-button>
    }

    @if (this.show().showHidden) {
      <cam-button
        [size]="this.size()"
        [icon]="this.showHidden ? 'eye-closed' : 'eye'"
        [type]="this.showHidden ? 'primary' : 'secondary'"
        (action)="this.toggleShowHidden()"
      ></cam-button>
    }

    @if (this.show().expand) {
      <cam-button
        [size]="this.size()"
        [icon]="this.expanded ? 'collapse' : 'expand'"
        [type]="this.expanded ? 'primary' : 'secondary'"
        (action)="this.toggleExpanded()"
      ></cam-button>
    }

    @if (this.show().shortcuts) {
      <cam-editabled-shortcuts-info [gridId]="this.gridId()" [size]="this.size()"></cam-editabled-shortcuts-info>
    }

    @if (this.breakpoints.isDesktop && this.show().switchView) {
      <cam-segmented-button
        type="secondary"
        [size]="this.size()"
        [options]="this.viewOptions()"
        [selected]="this.displayType()"
        (selectedChange)="this.switchView($event ?? 'grid')"
      ></cam-segmented-button>
    }
  </div>
}
